import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, Col, Image, Pagination, Row } from "antd";
import { ProjectsContext } from "../context/ProjectsContext";

const Projects = () => {
  const { projects, setProjectsForType, currentType } =
    useContext(ProjectsContext);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 8;
  const params = useParams();

  useEffect(() => {
    const type = params.projectType;
    if (type) {
      setProjectsForType(type);
    }
  }, [params.projectType, setProjectsForType]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const startIndex = (currentPage - 1) * pageSize;
  const visibleProjects = projects.slice(startIndex, startIndex + pageSize);

  return (
    <>
      <h2 className="text-4xl md:text-5xl text-[#031c3f] font-bold pt-24 text-center mb-8 lg:mb-12">
        {currentType.toUpperCase()} PROJECTS
      </h2>
      <Row gutter={[16, 16]} justify="center">
        {projects.length > 0 ? (
          visibleProjects.map((project, index) => (
            <Col key={index} xs={24} sm={12} md={8} lg={6} xl={6}>
              <Card
                hoverable
                style={{ width: "100%" }}
                className="h-full flex flex-col shadow-md rounded-lg overflow-hidden transition-all duration-300 hover:shadow-xl border border-gray-200"
                cover={
                  <Image.PreviewGroup items={project.images}>
                    <Image
                      src={project.images[0]}
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "cover",
                      }}
                    />
                  </Image.PreviewGroup>
                }
              >
                <div className="flex-grow flex flex-col text-center py-3 space-y-2 text-sm text-gray-700 break-words">
                  <h3 className="text-lg font-bold text-[#031c3f] text-center">
                    {project.location}
                  </h3>
                  <h4 className="text-lg font-bold text-[#031c3f] text-center">
                    {project.owner}
                  </h4>
                  <div>
                    <strong>System Capacity:</strong> {project.capacity}
                  </div>
                  <div>
                    <strong>Inverter Type:</strong> {project.inverter}
                  </div>
                  <div>
                    <strong>Panel Details:</strong> {project.panel}
                  </div>
                </div>
              </Card>
            </Col>
          ))
        ) : (
          <p>No projects available. Please select a category.</p>
        )}
      </Row>

      <div className="flex justify-center mt-6">
        <Pagination
          current={currentPage}
          pageSize={pageSize}
          total={projects.length}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>
    </>
  );
};

export default Projects;
